import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import Layout from "./Componentes/Layout";

//Página principal
import PaginaPrincipal from "./Paginas/PaginaPrincipal/PaginaPrincipal";

//Páginas para los productos
import Productos from './Paginas/Productos/Productos';

import Colchones from './Paginas/Productos/Categorias/Colchones';
import CamasBoxTarimas from './Paginas/Productos/Categorias/CamasBoxTarimas';
import Dormitorios from "./Paginas/Productos/Categorias/Dormitorios";
import CamasFuncionales from './Paginas/Productos/Categorias/CamasFuncionales';
import Cabeceras from './Paginas/Productos/Categorias/Cabeceras';
import Sofas from './Paginas/Productos/Categorias/Sofas';
// import Complementos from './Paginas/Productos/Categorias/Complementos';

import PaginaProducto from './Paginas/PaginaProducto/PaginaProducto';

import Ofertas from "./Paginas/Ofertas/Ofertas";

//Página para productos favoritos en localstorage
import Favoritos from "./Paginas/Favoritos/Favoritos";

//Páginas de nosotros y contenido adicional
import Nosotros from "./Paginas/Nosotros/Nosotros";

import ProyectosYAlianzas from "./Paginas/ProyectosYAlianzas/ProyectosYAlianzas";

import PropiedadIntelectual from "./Paginas/Nosotros/Paginas/PropiedadIntelectual";
import RazonesParaComprar from "./Paginas/Nosotros/Paginas/RazonesParaComprar";
import MediosDePago from './Paginas/ServicioAlCliente/MediosDePago';
import Manual from './Paginas/ServicioAlCliente/Manual/Manual'
import GarantiaDeProductos from "./Paginas/ServicioAlCliente/GarantiaDeProductos/GarantiaDeProductos";
import GarantiaColchones from "./Paginas/ServicioAlCliente/GarantiaDeProductos/Paginas/Colchones";
import GarantiaTarimas from "./Paginas/ServicioAlCliente/GarantiaDeProductos/Paginas/Tarimas";
import GarantiaCabeceras from "./Paginas/ServicioAlCliente/GarantiaDeProductos/Paginas/Cabeceras";
import RecomendacionesDeUso from "./Paginas/ServicioAlCliente/RecomendacionesDeUso/RecomendacionesDeUso";
import RecomendacionesColchones from "./Paginas/ServicioAlCliente/RecomendacionesDeUso/Paginas/Colchones";
import RecomendacionesTarimas from "./Paginas/ServicioAlCliente/RecomendacionesDeUso/Paginas/Tarimas";
import RecomendacionesCabeceras from "./Paginas/ServicioAlCliente/RecomendacionesDeUso/Paginas/Cabeceras";
import PoliticaDeCambiosYDevoluciones from "./Paginas/ServicioAlCliente/PoliticaDeCambiosYDevoluciones";
import PrivacidadYSeguridad from './Paginas/ServicioAlCliente/PrivacidadYSeguridad';
import TerminosYCondiciones from './Paginas/ServicioAlCliente/TerminosYCondiciones';
import HorariosDeEntrega from './Paginas/ServicioAlCliente/HorariosDeEntrega';
import ProgramaDeInfluencers from './Paginas/Novedades/ProgramaDeInfluencers';
import ProgramaDeReferencias from './Paginas/Novedades/ProgramaDeReferencias';

//Páginas de envios
import EnviosALimaYCallao from "./Paginas/Nosotros/Paginas/Envios/EnviosALimaYCallao/EnviosALimaYCallao";
import EnviosAProvincia from './Paginas/Nosotros/Paginas/Envios/EnviosAProvincia/EnviosAProvincia';

import CostosDeEnvioPorZonas from "./Paginas/Nosotros/Paginas/CostosDeEnvioPorZonas/CostosDeEnvioPorZonas";

//Páginas de contacto
import Contacto from "./Paginas/Contacto/Contacto";
import LibroDeReclamaciones from "./Paginas/Contacto/LibroDeReclamaciones/LibroDeReclamaciones";

//Página para resultado de búsquedas
import Busqueda from "./Paginas/Busqueda/Busqueda";

//Página para control de error 404
import Error404 from "./Paginas/Error404/Error404";

//Páginas para los vendedores
import Colores from './Paginas/Vendedores/Colores/Colores';
import Agencias from './Paginas/Vendedores/Agencias/Agencias';

// Importar el wrapper de complementos
import ComplementosWrapper from './Paginas/Productos/Categorias/ComplementosWrapper';

import './App.css';

function App(){
    return(
        <HelmetProvider>
            <Router>
                <Routes>
                    <Route path="/paleta-de-colores/" element={<Colores/>}/>

                    <Route element={<Layout/>}>
                        <Route path="/" element={<PaginaPrincipal/>} />

                        <Route path="/productos/" element={<Productos />} />

                        <Route path="/productos/colchones/" element={<Colchones />} />
                        <Route path="/productos/colchones/:sub1/:sub2/:sub3/" element={<PaginaProducto />} />
                        <Route path="/productos/colchones/:sub1?/:sub2?/:sub3?" element={<Colchones />} />

                        <Route path="/productos/camas-box-tarimas/" element={<CamasBoxTarimas />} />
                        <Route path="/productos/camas-box-tarimas/:sub1/:sub2/:sub3/:sub4/" element={<PaginaProducto />} />
                        <Route path="/productos/camas-box-tarimas/:sub1?/:sub2?/:sub3?/:sub4?/" element={<CamasBoxTarimas />} />

                        <Route path="/productos/dormitorios/:sub1/:sub2/:sub3/:sub4/:sub5" element={<PaginaProducto />} />
                        <Route path="/productos/dormitorios/:sub1?/:sub2?/:sub3?/:sub4?" element={<Dormitorios />} />
                        <Route path="/productos/dormitorios/" element={<Dormitorios />} />

                        <Route path="/productos/camas-funcionales/:sub1/:sub2/:sub3/:sub4/:sub5" element={<PaginaProducto />} />
                        <Route path="/productos/camas-funcionales/:sub1?/:sub2?/:sub3?/:sub4?" element={<CamasFuncionales />} />
                        <Route path="/productos/camas-funcionales/" element={<CamasFuncionales />} />

                        <Route path="/productos/cabeceras/:sub1/:sub2/:sub3/:sub4" element={<PaginaProducto />} />
                        <Route path="/productos/cabeceras/:sub1?/:sub2?/:sub3?" element={<Cabeceras />} />
                        <Route path="/productos/cabeceras/" element={<Cabeceras />} />

                        <Route path="/productos/sofas/" element={<Sofas />} />

                        {/* Rutas específicas de sofa-cama - DEBEN IR PRIMERO */}
                        <Route path="/productos/sofas/sofa-cama/:tamaño/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/sofa-cama/:tamaño/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/sofa-cama/:tamaño/" element={<Sofas />} />
                        <Route path="/productos/sofas/sofa-cama/" element={<Sofas />} />

                        {/* Otras rutas específicas de tipos de sofá */}
                        <Route path="/productos/sofas/butacas/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/butacas/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/butacas/" element={<Sofas />} />

                        <Route path="/productos/sofas/juegos-de-sala/:configuracion/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/juegos-de-sala/:configuracion/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/juegos-de-sala/:configuracion/" element={<Sofas />} />
                        <Route path="/productos/sofas/juegos-de-sala/" element={<Sofas />} />

                        <Route path="/productos/sofas/mecedoras/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/mecedoras/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/mecedoras/" element={<Sofas />} />

                        <Route path="/productos/sofas/reclinables/:cuerpos/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/reclinables/:cuerpos/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/reclinables/:cuerpos/" element={<Sofas />} />
                        <Route path="/productos/sofas/reclinables/" element={<Sofas />} />

                        <Route path="/productos/sofas/seccionales/:orientacion/:marca/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/seccionales/:orientacion/:marca/" element={<Sofas />} />
                        <Route path="/productos/sofas/seccionales/:orientacion/" element={<Sofas />} />
                        <Route path="/productos/sofas/seccionales/" element={<Sofas />} />

                        <Route path="/productos/sofas/:sub1/:sub2/:sub3/:sub4/:sub5/" element={<PaginaProducto />} />
                        <Route path="/productos/sofas/:sub1/:sub2/:sub3/:sub4/" element={<Sofas />} />
                        <Route path="/productos/sofas/:sub1/:sub2/:sub3/" element={<Sofas />} />
                        <Route path="/productos/sofas/:sub1/:sub2/" element={<Sofas />} />
                        <Route path="/productos/sofas/:sub1/" element={<Sofas />} />

                        <Route path="/productos/complementos/baules/clasicas/:id/" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/baules/:tipo/:id/" element={<PaginaProducto />} />
                        
                        <Route path="/productos/complementos/almohadas/:tipo/:id" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/sabanas-y-cobertores/:tipo/:id" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/bases/:tamaño/:marca/:tipo/:id" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/cama-perro/:tamaño/:marca/:id" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/puff/:estilo/:marca/:id" element={<PaginaProducto />} />
                        <Route path="/productos/complementos/veladores/:marca/:id" element={<PaginaProducto />} />

                        <Route path="/productos/complementos/:sub1/:sub2/:sub3/:sub4/:sub5" element={<PaginaProducto />} />

                        <Route path="/productos/complementos/*" element={<ComplementosWrapper />} />

                        <Route path="/ofertas/" element={<Ofertas/>} />

                        <Route path="/mis-favoritos/" element={<Favoritos/>} />

                        <Route path="/nosotros/" element={<Nosotros/>} />

                        <Route path="/proyectos-y-alianzas/" element={<ProyectosYAlianzas/>} />

                        <Route path="/nosotros/razones-para-comprar/" element={<RazonesParaComprar/>}/>
                        <Route path="/nosotros/propiedad-intelectual/" element={<PropiedadIntelectual/>}/>

                        <Route path="/envios/envios-a-lima-y-callao/" element={<EnviosALimaYCallao/>}/>
                        <Route path="/envios/envios-a-provincia/" element={<EnviosAProvincia/>}/>

                        <Route path="/servicio-al-cliente/medios-de-pago/" element={<MediosDePago/>}/>
                        <Route path="/servicio-al-cliente/costos-de-envio-por-zona/" element={<CostosDeEnvioPorZonas/>}/>
                        <Route path="/servicio-al-cliente/garantia-de-productos/" element={<GarantiaDeProductos/>}/>
                        <Route path="/servicio-al-cliente/garantia-de-productos/colchones/" element={<GarantiaColchones/>}/>
                        <Route path="/servicio-al-cliente/garantia-de-productos/box-tarimas/" element={<GarantiaTarimas/>}/>
                        <Route path="/servicio-al-cliente/garantia-de-productos/cabeceras/" element={<GarantiaCabeceras/>}/>

                        <Route path="/servicio-al-cliente/manual-de-instalacion/" element={<Manual/>}/>
                        
                        <Route path="/servicio-al-cliente/recomendaciones-de-uso/" element={<RecomendacionesDeUso/>}/>
                        <Route path="/servicio-al-cliente/recomendaciones-de-uso/colchones/" element={<RecomendacionesColchones/>}/>
                        <Route path="/servicio-al-cliente/recomendaciones-de-uso/box-tarimas/" element={<RecomendacionesTarimas/>}/>
                        <Route path="/servicio-al-cliente/recomendaciones-de-uso/cabeceras/" element={<RecomendacionesCabeceras/>}/>

                        <Route path="/servicio-al-cliente/politica-de-cambios-y-devoluciones/" element={<PoliticaDeCambiosYDevoluciones/>}/>

                        <Route path="/servicio-al-cliente/privacidad-y-seguridad/" element={<PrivacidadYSeguridad/>}/>

                        <Route path="/servicio-al-cliente/terminos-y-condiciones/" element={<TerminosYCondiciones/>}/>

                        <Route path="/servicio-al-cliente/horarios-de-entrega-y-envios/" element={<HorariosDeEntrega/>}/>

                        <Route path="/novedades/programa-de-influencers/" element={<ProgramaDeInfluencers/>}/>
                        <Route path="/novedades/programa-de-referencias/" element={<ProgramaDeReferencias/>}/>

                        <Route path="/contacto/" element={<Contacto/>} />
                        <Route path="/contacto/libro-de-reclamaciones/" element={<LibroDeReclamaciones/>} />

                        <Route path="/busqueda/" element={<Busqueda/>} />

                        <Route path="*" element={<Error404/>}/>

                        <Route path="/vendedores/colores/" element={<Colores/>} />

                        <Route path="/agencias-recomendadas/" element={<Agencias/>} />
                    </Route>
                </Routes>
            </Router>
        </HelmetProvider>
    );
}

export default App;
